import { useCallback } from 'react';
import { ISignal, useCustomFetch } from "../custom-fetch";
import IOrganization from "../shared/IOrganization";

interface IGetOrganization extends ISignal {
  id: string;
}

export const useOrganizationsService = () => {
  const customFetch = useCustomFetch();

  const fetchOrganizations = useCallback(async ({ signal }: ISignal) => {
    const [organizations] = await customFetch<IOrganization[]>("/json/organizations", { signal });
    return organizations;
  }, [customFetch]);
  
  const getOrganization = useCallback(async ({ signal, id }: IGetOrganization) => {
    const [organization] = await customFetch<IOrganization>("/json/organizations?id=" + id, { signal });
    return organization;
  }, [customFetch]);
  
  const saveOrganization = useCallback(async (data: IOrganization) => {
    const [organization] = await customFetch<IOrganization>("/json/organizations/add", {
      method: "POST",
      body: JSON.stringify(data),
    });
    return organization;
  }, [customFetch]);
  
  const updateOrganization = useCallback(async (id: string, data: IOrganization) => {
    const [organization] = await customFetch<IOrganization>("/json/organizations/add", {
      method: "POST",
      body: JSON.stringify({ ...data, id }),
    });
    return organization;
  }, [customFetch]);
  
  const deleteOrganization = useCallback(async (id: string) => {
    await customFetch<IOrganization>("/json/organizations/delete", {
      method: "POST",
      body: JSON.stringify({ ids: [id] }),
    });
    return true;
  }, [customFetch]);

  const validateApiKey = useCallback(async (apiKey: string, previousApiKey: string) => {
    const [result] = await customFetch<string>("/json/organizations/validateapikey", {
      method: "POST",
      body: JSON.stringify({ apiKey, previousApiKey }),
    });
    return result;
  }, [customFetch]);

  const testCredentials = useCallback(async (organizationId: string) => {
    const [result] = await customFetch<string>("/json/organizations/testcredentials", {
      method: "POST",
      body: JSON.stringify({ organizationId }),
    });
    return result;
  }, [customFetch]);
  
  return { fetchOrganizations, getOrganization, saveOrganization, updateOrganization, deleteOrganization, validateApiKey, testCredentials };
}
